import classNames from 'classnames';
import {filter, map, orderBy} from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import swal from 'sweetalert2';
import Loader from '../../../../../components/Loader';
import copyToClipboard from '../../../../../helpers/copyToClipboard';
import {
  getChampionshipClubsByChampionshipId,
  getNextGameWeekByChampiomshipId,
} from '../../../../Tools/Tds/Widgets/TdsList/index';
import CheckPlayers from '../CheckPlayers';
import './PlayersListWidget.css';
import {
  getChampionshipPlayerPool
} from '../../../../../actions/entities/mxi/championshipPlayerPool';
import { getChampionshipCalendar } from '../../../../../actions/entities/mxi/championshipCalendar';
import { updatePlayer } from '../../../../../actions/entities/mxi/updatePlayer';

const initialState = {
  championship: 1,
  filters: {},
  orderBy: 'price',
  sortOrder: 'desc',
  players: {entities: []},
  focusedInputValue: '',
  protectedInputs: {
    price: true,
  },
  onlyActive: true,
  type: undefined,
  nextGameWeek: undefined,
  currentGameWeek: undefined,
};

class PlayersListWidget extends React.Component {
  constructor(props) {
    super(props);

    const state = initialState;
    if (props.championship) state.championship = props.championship;

    this.state = state;
  }

  fetchPlayerPool = e => {
    if (e) e.preventDefault();
    const {championship} = this.state;
    this.props.dispatch(getChampionshipPlayerPool(championship));
  };

  fetchCalendar = e => {
    if (e) e.preventDefault();
    const {championship} = this.state;
    this.props.dispatch(getChampionshipCalendar(championship));
  };

  updatePlayerPrice(player, e) {
    if (e) e.preventDefault();
    player && this.props.dispatch(updatePlayer(player.id, {price: Number(e.target.value)}));
  }

  updatePlayerLevel(player, e) {
    if (e) e.preventDefault();
    player && this.props.dispatch(updatePlayer(player.id, {playerLevel: Number(e.target.value)}));
  }

  selectOrChangeOrder(orderType) {
    if (orderType === this.state.orderBy)
      this.setState({
        sortOrder: this.state.sortOrder === 'asc' ? 'desc' : 'asc',
      });
    else {
      this.setState({orderBy: orderType});
      switch (orderType) {
        case 'price':
          this.setState({sortOrder: 'desc'});
          break;
        default:
          this.setState({sortOrder: 'asc'});
      }
    }
  }

  orderPlayers(players) {
    const {championshipClubsById, nextGameWeek} = this.state;
    switch (this.state.orderBy) {
      case 'club':
        return orderBy(
          players,
          [
            player =>
              championshipClubsById &&
              championshipClubsById[player.clubId] &&
              championshipClubsById[player.clubId].name['fr-FR'],
            'position',
          ],
          [this.state.sortOrder, 'asc'],
        );
      case 'name':
        return orderBy(
          players,
          ['lastName', 'price'],
          [this.state.sortOrder, 'desc'],
        );
      case 'position':
        return orderBy(
          players,
          ['position', 'lastName'],
          [this.state.sortOrder, 'asc'],
        );
      case 'ultraPosition':
        return orderBy(
          players,
          ['ultraPosition', 'lastName'],
          [this.state.sortOrder, 'asc'],
        );
      case 'level':
        return orderBy(
          players,
          ['lastGameWeek.playerLevel', 'lastName'],
          [this.state.sortOrder, 'asc'],
        );
      case 'evol':
        return orderBy(
          players,
          [player => player.price - player?.lastGameWeek?.price, 'lastName'],
          [this.state.sortOrder, 'asc'],
        );
      case 'status':
        return orderBy(
          players,
          ['lastGameWeek.playerPerformance.status', 'lastName'],
          [this.state.sortOrder, 'asc'],
        );
      case 'points':
        return orderBy(
          players,
          [player => player?.lastGameWeek?.playerPerformance?.points || 0, 'lastName'],
          [this.state.sortOrder, 'asc'],
        );
      default:
        return orderBy(
          players,
          ['price', 'lastName'],
          [this.state.sortOrder, 'asc'],
        );
    }
  }

  getOrderCaret(orderType) {
    if (orderType !== this.state.orderBy) return false;

    return `fa-caret-${this.state.sortOrder === 'desc' ? 'down' : 'up'}`;
  }

  filterPlayers(players) {
    map(this.state.filters, (value, key) => {
      if (value && value !== '') {
        switch (key) {
          case 'name':
            players = filter(
              players,
              player =>
                (player.lastName &&
                  player.lastName.match(new RegExp(value, 'gi'))) ||
                (player.firstName &&
                  player.firstName.match(new RegExp(value, 'gi'))) ||
                player.id.match(new RegExp(value, 'gi')),
            );
            break;
          case 'club':
            players = filter(players, {clubId: value});
            break;
          case 'position':
            players = filter(players, {position: parseInt(value, 10)});
            break;
          case 'ultraPosition':
            players = filter(players, player => {
              if (value === 'Unknown') {
                if (!player.ultraPosition) {
                  return player;
                }
              } else {
                return player.ultraPosition === parseInt(value, 10);
              }
            });
            break;
          case 'price':
            players = filter(
              players,
              player => player.price >= parseInt(value, 10),
            );
            break;
          default:
            return players;
        }
      }
    });

    return players;
  }

  protectInput(inputName) {
    const {protectedInputs} = this.state;
    const checked = protectedInputs[inputName];
    if (checked !== undefined) {
      this.setState({
        protectedInputs: {...protectedInputs, [inputName]: !checked},
      });
    }
  }

  changeChampionship(championship) {
    this.setState({championship});
    this.props.history.replace({
      pathname: this.props.location.pathname,
      search: `?championship=${championship}`,
    });
  }

  componentDidMount() {
    this.fetchPlayerPool();
    this.fetchCalendar();
    this.props.dispatch(
      getChampionshipClubsByChampionshipId(
        (championshipClubsByChampionshipId, clubs) => {
          this.setState({
            championshipClubsByChampionshipId,
          });
          this.setState({
            championshipClubsById: clubs,
          });
        },
      ),
    );
    this.props.dispatch(
      getNextGameWeekByChampiomshipId({
        championshipId: this.state.championship,
        onSuccess: nextGameWeek => {
          this.setState({
            nextGameWeek: nextGameWeek.gameWeek.gameWeekNumber,
          });
        },
      }),
    );
  }

  componentDidUpdate(_prevProps, prevState) {
    if (prevState.championship !== this.state.championship)
      this.fetchPlayerPool();

    if (
      prevState.orderBy !== this.state.orderBy ||
      prevState.sortOrder !== this.state.sortOrder
    ) {
      this.setState({players: this.orderPlayers(this.state.players)});
    }

    if (
      prevState.filters !== this.state.filters ||
      prevState.onlyActive !== this.state.onlyActive
    )
      this.setState({
        players: this.orderPlayers(
          this.filterPlayers(this.props.players.entities),
        ),
      });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.players.entities !== this.props.players.entities)
      this.setState({
        players: this.filterPlayers(this.orderPlayers(nextProps.players.entities)),
      });

      const gameWeeks = Object.values(nextProps?.gameWeeks?.gameWeeks || {});
      const currentGameWeek = gameWeeks?.find(item => item.status === 1);
      const pastGameWeek = gameWeeks?.find(item => item.gameWeekNumber === this.state.nextGameWeek - 1);

      this.setState({
        type: currentGameWeek ? 'update' : pastGameWeek?.status === -1 ? 'open' : undefined,
        currentGameWeek: currentGameWeek ? currentGameWeek?.gameWeekNumber : pastGameWeek?.status === -1 ? this.state.nextGameWeek : undefined,
      });
  }

  renderNoResult() {
    return (
      !this.props.isFetching && (
        <div className="no-result text-center">
          <h4 className="text-red">
            <i className="fa fa-meh-o" /> Oh! we couldn't find any players
            corresponding to your request.
          </h4>
        </div>
      )
    );
  }

  getUltraPosition(value) {
    switch (value) {
      case 10:
        return 'G';
      case 20:
        return 'DC';
      case 21:
        return 'DL';
      case 30:
        return 'MD';
      case 31:
        return 'MO';
      case 40:
        return 'A';
      default:
        break;
    }
  }

  getPlayerStatus(status) {
    switch (status) {
      case 1:
        return 'starter';
      case 2:
      case 3:
        return 'substitute';
      case 4:
        return 'injured';
      case 5: 
        return 'suspended';
      case 6: 
        return 'not in group';
      default:
        break;
    }
  }

  renderBody() {
    const {championshipClubsById, players} = this.state;

    if (players?.length < 1) return this.renderNoResult();
    return (
      <table className="table table-responsive table-striped">
        <thead>
          <tr>
            <th className="id">ID</th>
            <th>
              <a onClick={() => this.selectOrChangeOrder('name')}>
                Name&nbsp;
                <i className={classNames('fa', this.getOrderCaret('name'))} />
              </a>
            </th>
            <th>
              <a onClick={() => this.selectOrChangeOrder('ultraPosition')}>
                Position&nbsp;
                <i
                  className={classNames(
                    'fa',
                    this.getOrderCaret('ultraPosition'),
                  )}
                />
              </a>
            </th>
            <th>
              <a onClick={() => this.selectOrChangeOrder('club')}>
                Club&nbsp;
                <i className={classNames('fa', this.getOrderCaret('club'))} />
              </a>
            </th>
            <th className="text-center">
              <a onClick={() => this.selectOrChangeOrder('level')}>
                Player Level&nbsp;
                <i className={classNames('fa', this.getOrderCaret('level'))} />
              </a>
            </th>
            <th className="text-center">
              <a onClick={() => this.selectOrChangeOrder('evol')}>
                Evol GW-1&nbsp;
                <i className={classNames('fa', this.getOrderCaret('evol'))} />
              </a>
            </th>
            <th className="text-center">
              <a onClick={() => this.selectOrChangeOrder('status')}>
                Status GW-1&nbsp;
                <i className={classNames('fa', this.getOrderCaret('status'))} />
              </a>
            </th>
            <th className="text-center">
              <a onClick={() => this.selectOrChangeOrder('points')}>
                Points MXI GW-1&nbsp;
                <i className={classNames('fa', this.getOrderCaret('points'))} />
              </a>
            </th>
            <th className="text-center">
              <span className="small ml-2">
                <input
                  type="checkbox"
                  id="protected-position"
                  name="protected-position"
                  checked={this.state.protectedInputs.price}
                  onChange={() => this.protectInput('price')}
                />
                  &nbsp;
                <label htmlFor="protected-position">protect</label>
              </span>
              <br />
              <a onClick={() => this.selectOrChangeOrder('price')}>
                Price&nbsp;
                <i className={classNames('fa', this.getOrderCaret('price'))} />
              </a>
            </th>
          </tr>
        </thead>
        <tbody>
          {map(
            players,
            (
              {
                id,
                firstName,
                lastName,
                clubId,
                ultraPosition,
                lastGameWeek,
                price,
                playerLevel,
              },
              key,
            ) => (
              <tr key={key} id={id} className="player">
                <td className="id" onClick={() => copyToClipboard(id)}>
                  {id && id.replace('mpg_championship_player_', '')}
                </td>
                <th>
                  {firstName} <span className="text-uppercase">{lastName}</span>
                </th>
                <td>
                  {this.getUltraPosition(ultraPosition)}
                </td>
                <td data-id={clubId} title={clubId}>
                  {championshipClubsById &&
                    championshipClubsById[clubId] &&
                    championshipClubsById[clubId].name['fr-FR']}
                </td>
                <td className="player-level">
                  <div
                    className={classNames('form-group text-center select')}>
                    <select
                      tabIndex={key + players.length * 2}
                      className="form-control"
                      value={playerLevel || 0}
                      onChange={e => {
                        players[key].playerLevel = parseInt(
                          e.target.value,
                          10,
                        );
                        this.setState({players});
                        this.updatePlayerLevel(players[key], e);
                      }}>
                      <option value={0}></option>
                      <option value={1}>1</option>
                      <option value={2}>2</option>
                      <option value={3}>3</option>
                      <option value={4}>4</option>
                    </select>
                    <i />
                  </div>
                </td>
                <td className="text-center">
                  {price - lastGameWeek?.price > 0 ? '+' : ''}{price - lastGameWeek?.price}
                  <br />
                </td>
                <td className="text-center">
                  {this.getPlayerStatus(lastGameWeek?.playerPerformance?.status || 0)}
                  <br />
                </td>
                <td className="text-center">
                  {lastGameWeek?.playerPerformance?.points || 0}
                  <br />
                </td>
                <td className="text-center quotation">
                  <input
                    tabIndex={key}
                    type="number"
                    min={0}
                    disabled={this.state.protectedInputs.price}
                    value={price || ''}
                    className="form-control inputQuotation text-center quotationColor"
                    onBlur={e => {
                      const player = players[key];
                      if (!player || !e.target.value) {
                        swal({
                          title: `Oops...`,
                          type: 'error',
                          html: "Price can't be null",
                        });
                      } else {
                        this.updatePlayerPrice(player, e);
                      }
                    }}
                    onChange={e => {
                      players[key].price = parseInt(e.target.value, 10);
                      this.setState({players});
                    }}
                  />
                </td>
              </tr>
            ),
          )}
        </tbody>
      </table>
    );
  }

  resetFilters = () => {
    document.getElementById('filter1').value = '';
    document.getElementById('filter2').value = '';
    document.getElementById('filter3').value = '';
    document.getElementById('filter4').value = '';
    document.getElementById('filter5').value = '';

    this.setState({
      filters: {},
      orderBy: 'price',
      sortOrder: 'desc',
    });
  };

  setRef = key => ref => (this[key] = ref);

  renderCheckPlayersModal() {
    return (
      <div id="checkPlayers" class="modal fade" role="dialog">
        <div class="modal-dialog">
          <div class="modal-body">
            <CheckPlayers
              clubsById={this.state.championshipClubsById}
              players={this.state.players}
              ref={this.setRef('checkPlayers')}
              championship={this.props.championship}
              type={this.state.type}
              gameWeek={this.state?.currentGameWeek}
            />
          </div>
        </div>
      </div>
    );
  }

  renderButtons() {
    const {currentGameWeek, type} = this.state;
    return (
      <div>
        <div style={{display: 'flex', flexDirection: 'row'}}>
          <div style={{flex: 1, margin: 8}}>
            <button
              type="button"
              onClick={() =>
                this.checkPlayers.open({
                  onSuccess: () => {
                    this.fetchPlayerPool()
                    this.fetchCalendar()
                  },
                  title: `Modale Pré Confirmation ${type.toUpperCase()} GameWeek ${currentGameWeek}`,
                  gameWeek: this.state.currentGameWeek,
                })
              }
              data-toggle="modal"
              data-target="#checkPlayers"
              className="btn btn-danger btn-block">
              <i className="fa fa-refresh" /> {type.toUpperCase()} J{currentGameWeek}
            </button>
          </div>
        </div>
      </div>
    );
  }

  renderFilters() {
    const {championshipClubsByChampionshipId, championship} = this.state;
    const clubOptions = orderBy(
      !!championshipClubsByChampionshipId &&
        championshipClubsByChampionshipId[championship],
      [championship => championship.name['fr-FR']],
      ['asc'],
    );

    return (
      <div className="box-footer">
        <form className="row">
          <div className="col-sm-6 col-md-2">
            <input
              id="filter1"
              type="text"
              className="form-control"
              placeholder="Name of a player"
              onChange={e =>
                this.setState({
                  filters: {
                    ...this.state.filters,
                    name: e.target.value.length > 2 ? e.target.value : '',
                  },
                })
              }
              disabled={this.props.isFetching}
            />
          </div>
          <div className="col-sm-6 col-md-2">
            <select
              id="filter2"
              className="form-control"
              value={this.state.filters.club}
              onChange={e =>
                this.setState({
                  filters: {
                    ...this.state.filters,
                    club: e.target.value,
                  },
                })
              }
              disabled={this.props.isFetching}>
              <option value="">All clubs</option>
              {clubOptions.map((club, key) => (
                <option key={key} value={club.id}>
                  {club.name['fr-FR']}
                </option>
              ))}
            </select>
          </div>
          <div className="col-sm-6 col-md-2">
            <select
              id="filter3"
              className="form-control"
              value={this.state.filters.position}
              onChange={e =>
                this.setState({
                  filters: {
                    ...this.state.filters,
                    position: e.target.value,
                  },
                })
              }
              disabled={this.props.isFetching}>
              <option value="">All positions</option>
              <option value="1">Goal Keepers</option>
              <option value="2">Defenders</option>
              <option value="3">Midfielders</option>
              <option value="4">Strikers</option>
            </select>
          </div>
          <div className="col-sm-6 col-md-2">
            <select
              id="filter4"
              className="form-control"
              value={this.state.filters.ultraPosition}
              onChange={e =>
                this.setState({
                  filters: {
                    ...this.state.filters,
                    ultraPosition: e.target.value,
                  },
                })
              }
              disabled={this.props.isFetching}>
              <option value="">All Ultra positions</option>
              <option value="10">Goal Keepers</option>
              <option value="20">Defenders</option>
              <option value="21">Wing Back</option>
              <option value="30">Defensive Midfielders</option>
              <option value="31">Attacking Midfielders</option>
              <option value="40">Strikers</option>
            </select>
          </div>
          <div className="col-sm-6 col-md-2">
            <select
              id="filter5"
              className="form-control"
              value={this.state.filters.price}
              onChange={e =>
                this.setState({
                  filters: {
                    ...this.state.filters,
                    price: e.target.value,
                  },
                })
              }
              disabled={this.props.isFetching}>
              <option value="">All quotations</option>
              <option value="10">More than 10</option>
              <option value="20">More than 20</option>
              <option value="30">More than 30</option>
            </select>
          </div>
          <div className="col-sm-6 col-md-2">
            <button
              type="button"
              onClick={this.resetFilters}
              className="btn btn-warning buttonReset btn-block">
              <i className="fa fa-times" /> Reset filters
            </button>
          </div>
        </form>
      </div>
    );
  }

  render() {
    const {isFetching} = this.props;

    return (
      <div id="full-players-list-widget" className="row">
        <div className="col-md-12">
          <div className="box box-default">
            <div className="box-header with-border">
              <h3 className="box-title pull-left">
                <i className="fa fa-address-card-o" /> Players list
              </h3>
              {/* <div className="box-tools pull-right">
                <ChampionshipSelector
                  championship={championship}
                  onChange={c => this.changeChampionship(c)}
                />
              </div> */}
            </div>
            {this.renderCheckPlayersModal()}
            {this.state.type && this.renderButtons()}
            {this.renderFilters()}
            <div className="box-body">{this.renderBody()}</div>
            {isFetching && <Loader />}
          </div>
        </div>
      </div>
    );
  }
}

PlayersListWidget.propTypes = {
  championship: PropTypes.number,
};

export default withRouter(
  connect(
    state => ({
      isFetching: state.app.players.info.isFetching || state.app.mxi.championshipCalendar.isFetching,
      players: {entities: state.app.mxi.championshipPlayerPool.data},
      gameWeeks: state.app.mxi.championshipCalendar.data,
    }),
    dispatch => ({dispatch}),
  )(PlayersListWidget),
);



// WEBPACK FOOTER //
// ./src/pages/MXI/Players/Widgets/PlayersList/index.js